<template>
  <div>
    <a-modal v-model="selectOrderFrozenible" footer="'" title="冻结订单" width="650px">
      <a-form :form="formselectOrderManualFrozen" >
        <a-row >
          <a-col>
            <a-form-item label="请选择" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-select @change="Freezing"  v-decorator="['reason', { rules: [{ required: true, message: '请填写冻结原因!' }] }]"    >
                <a-select-option  v-for="type in freeze_type" :title="type.dictValue" :key="type.dictValue">{{type.dictLabel}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="冻结原因" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input :class="[disable1?'disEvents':'']" v-model="reason2"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="冻结解除时间">
              <a-date-picker
                :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
                @change="onChangetemporarily"
                v-decorator="['frozenRecovery', { rules: [{  required: true, message: '请选择冻结解除时间!' }] }]"
                format="YYYY-MM-DD HH:mm:ss"
                style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-row type="flex" justify="end">
              <a-col :span="10" style="padding: 10px">
                <a-button type="primary" @click="orderFrozenManual" > 冻结
                </a-button>
                <a-button v-if='dataselectOrderManualFrozen' type="primary" @click="orderRemoveSubstatus" style="margin-left: 15px">
                  取消冻结
                </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
      <a-table size="default" ref="table"  :columns="columns"
               :dataSource="this.orderFrozen"
               :pagination="false" bordered>
      </a-table>
    </a-modal>
  </div>

</template>

<script>
   import pick from 'lodash.pick'
  import moment from 'moment';
  import {getselectOrderFrozen,getselectOrderManualFrozen,getorderRemoveSubstatus,getorderFrozenManual} from
      '@/api/order/editorder'
   import {
     getfinddictAll}
     from '@/api/order/orderList'
    export default {
        name: "selectOrderFrozenModel",
      components: {
      },
      data() {
        return {
          disable1:true,
          reason2:'',
          freeze_type:[],
          labelCol: {
            xs: { span: 24 },
            sm: { span: 5 }
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
          },
          formselectOrderManualFrozen: this.$form.createForm(this),
          selectOrderFrozenible:false,
          format: 'YYYY/MM/DD HH:mm:ss',
          orderFrozen:[],
          columns:[
            {
              title: '序号',
              customRender: (text, record, index) => `${index + 1}`,align: 'center'
            },
            {title: '冻结原因', dataIndex: 'reason',align: 'center'},
            {title: '冻结方式', dataIndex: 'frozenType',align: 'center'},
            {
              title: '解冻时间',
              dataIndex: 'frozenRecovery',
              align: 'center'
            },{
              title: '操作人',
              dataIndex: 'oprUser',
              align: 'center'
            },{
              title: '操作时间',
              dataIndex: 'oprTime',
              align: 'center'
            },

          ],
          orderId:'',
          frozenRecovery:'',
          orderRemove:{},
          dataselectOrderManualFrozen:''
        }
      },
      methods: {
        // 冻结原因
        Freezing(value){
         console.log('value',value)
          if(value != 3) {

            for (var i = 0; i < this.freeze_type.length; i++) {
              if (value == this.freeze_type[i].dictValue) {
                this.reason2 = this.freeze_type[i].dictLabel
              }
            }
          }else{
            this.reason2 = ''
            this.disable1 = false
          }
        },

        moment,
        // 冻结
        orderFrozenManual(){
          console.log('this.reason2',this.reason2)
          this.formselectOrderManualFrozen.validateFields((err, values) => {
            values.orderId=this.orderId
            values.orderStatus='ORDER_FROZEN'
            values.orderStatusType='ORDER_FROZEN'
            values.manualRelease=1
            if(this.reason2 !=''){
              values.reason = this.reason2
            }else{
              this.$message.error('请输入冻结原因');
              return
            }

            if(this.frozenRecovery){
              values.recoveryTime=this.frozenRecovery
            }else {
              values.recoveryTime=this.dataselectOrderManualFrozen.frozenRecovery
            }
            // console.log(values)
            if (!err) {
              getorderFrozenManual(values).then(res=>{
                if (res.code === 0){
                  this.$emit('selectorderok')
                  this.$message.success('操作成功');
                  getselectOrderFrozen({orderId:this.orderId}).then(res=>{
                    if (res.code === 0){
                      this.orderFrozen=res.rows
                    }else {
                      this.$message.error(res.msg);
                    }
                  })
                  this.selectOrderFrozenible=false
                }else {
                  this.$message.error(res.msg);
                }
              })
            }
          })
        },
        // 取消冻结
        orderRemoveSubstatus(){
          this.orderRemove.orderStatus='ORDER_FROZEN'
          this.orderRemove.orderId= this.orderId
          this.orderRemove.orderStatusType= 'ORDER_FROZEN'
          this.orderRemove.manualRelease=1
          getorderRemoveSubstatus(this.orderRemove).then(res=>{
            if (res.code === 0){
              this.$emit('selectorderok')

              this.$message.success('操作成功');
              getselectOrderFrozen({orderId:this.orderId}).then(res=>{
                if (res.code === 0){
                  this.orderFrozen=res.rows
                }else {
                  this.$message.error(res.msg);
                }
              })
              this.selectOrderFrozenible=false
            }else {
              this.$message.error(res.msg);
            }
          })
        },
        // 解除冻结时间
        onChangetemporarily(date, dateString) {
          this.frozenRecovery=dateString
          // console.log(date, dateString);
        },
        // 弹出 冻结弹框
        showselectOrderFrozen(id){
          this.orderId=id
          this.formselectOrderManualFrozen.resetFields()
          getselectOrderFrozen({orderId:id}).then(res=>{
             if (res.code === 0){
               this.orderFrozen=res.rows
               this.selectOrderFrozenible=true
               this.reason2 =''
               let dictTypes=['freeze_type']
               getfinddictAll({dictTypes:dictTypes.join()}).then(res => {
                 console.log('res',res)
                 this.freeze_type = res.freeze_type
                 getselectOrderManualFrozen({ orderId: this.orderId }).then(res => {
                   if (res.code === 0) {
                     this.dataselectOrderManualFrozen = res.data
                     // if (res.data) {
                     //   setTimeout(() => this.formselectOrderManualFrozen.setFieldsValue({
                     //     frozenRecovery: moment(res.data.frozenRecovery, this.format),
                     //     reason: res.data.reason
                     //   }), 16)
                     // } else {
                     //   this.formselectOrderManualFrozen.resetFields()
                     // }
                   } else {
                     this.$message.error(res.msg);
                   }
                 })
               })
            }else {
             this.$message.error(res.msg);
            }
          })
        },
      }
    }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {padding: 6px 16px;}

  .disEvents{
    pointer-events: none;
  }
</style>